export default __webpack_public_path__ + "static/media/tweet1.d2655465.png";